<atn-ds-table [config]="appPagesTableConfigSg()" />

<atn-admin-app-page-modal />

@if (
  appPagesEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  @let deletionError =
    appPagesEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete app page"
    description="
      Deleting your app page can't be undone. Are you sure you want to delete your app page?
    "
    [error]="deletionError"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="DELETE"
  />
}
